import { LifeCycleTypes } from '@formily/core';
import { generatorLatest } from './utils/generatorLatest';

function parseParams(arr) {
  const key = arr[0];
  const cb = arr[arr.length - 1];

  if (arr.length === 2) {
    return {
      key,
      cb,
      changeEventType: LifeCycleTypes.ON_FIELD_VALUE_CHANGE
    };
  }

  return {
    key,
    cb,
    changeEventType: arr[1].changeEventType
  };
}

export const genOnFieldValueChange = $ => {
  const onFieldValueChange = (...arr) => {
    if (arr.length === 1) {
      return $(LifeCycleTypes.ON_FIELD_VALUE_CHANGE, arr[0]);
    }

    const {
      key,
      cb,
      changeEventType
    } = parseParams(arr); // trick的方法防止组件初始化的值，触发ON_FIELD_VALUE_CHANGE

    const changeMap = new Map();
    const generatorCb = generatorLatest(cb);
    $(changeEventType, key).subscribe(s => {
      const path = s.path;

      if (s.initialValue == null) {
        changeMap.set(path, true);
      }

      if (!changeMap.get(path)) {
        changeMap.set(path, true);
        return;
      }

      generatorCb(s);
    });
  };

  return onFieldValueChange;
};
//# sourceMappingURL=es/Form/extendsEffects/onFieldValueChange.js.map